import { moduleProviderFactory } from 'core/providers';
import { PatientList, PatientPreview, PatientSalesOrderList, PatientTemplateList, SalesOrderPreview, TemplatePreview } from 'application/patient/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.patient',
                pattern: '/patients',
                children: [
                    {
                        name: 'master.app.main.patient.list',
                        pattern: '',
                        tabTitle: 'PATIENT.LIST.TITLE',
                        component: PatientList,
                        data: {
                            title: 'PATIENT.LIST.TITLE'
                        }
                    },
                    {
                        name: 'master.app.main.patient.preview',
                        pattern: '/preview/:id/:firstName/:lastName/',
                        children: [
                            {
                                name: 'master.app.main.patient.preview.general',
                                pattern: 'general',
                                tabTitle: 'Patient Details',
                                component: PatientPreview,    
                                data: {
                                    title: 'Patient Details',
                                    crumbs: {
                                        title: 'General',
                                        route: 'master.app.main.patient.preview.general'
                                    }
                                }
                            },
                              {
                                 name: 'master.app.main.patient.preview.orders',
                                 pattern: 'orders',
                                 tabTitle: 'Patient Orders',
                                 component: PatientSalesOrderList,
                                 data: {
                                     title: 'Patient Orders',
                                     crumbs: {
                                        title: 'Orders',
                                        route: 'master.app.main.patient.preview.orders'
                                    } 
                                 }
                             }, 
                              {
                                 name: 'master.app.main.patient.preview.templates',
                                 pattern: 'templates',
                                 tabTitle: 'Patient Templates',
                                 component: PatientTemplateList,
                                 data: {
                                     title: 'Patient Templates',
                                     crumbs: {
                                        title: 'Templates',
                                        route: 'master.app.main.patient.preview.templates'
                                    } 
                                } 
                            },
                             {
                                name: 'master.app.main.patient.preview.templates.preview',
                                pattern: 'templates/:templateId',
                                tabTitle: 'Patient Template Preview',
                                component: TemplatePreview,
                                data: {
                                    title: 'Patient Template'
                                }
                            }, 
                            {
                                name: 'master.app.main.patient.preview.orders.preview',
                                pattern: 'orders/:orderId',
                                tabTitle: 'Patient Order Preview',
                                component: SalesOrderPreview,
                                data: {
                                    title: 'Patient Order'
                                }
                            }                             
                        ]
                    }              
                ]
            }
        ],
        menu : [
            {
                title: 'MENU.FACILITY_ORDERS',
                order: 5,
                icon: 'package',
                authorization: 'coreUserSection.read',
                subMenu: [
                    {
                        title: 'MENU.PATIENTS',
                        route: 'master.app.main.patient.list',
                        order: 9,
                    }                    
                ]
            }
        ]
    });
})();